module.exports = __webpack_public_path__ + "static/media/loc2_img15.a1ba2c61.jpg";